module.exports = __webpack_public_path__ + "static/media/Empty_State@2x.9b049d8d.png";